/* tslint:disable */ /* eslint-disable */
import * as Types from '../../../models/generated/index';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ExportResponsesQueryVariables = Types.Exact<{
  scheduledSurveyId: Types.Scalars['Int'];
  language?: Types.InputMaybe<Types.Supported_Language_Code>;
  attributeValueIds: Array<Types.Scalars['Int']> | Types.Scalars['Int'];
}>;


export type ExportResponsesQuery = { exportResponses: string };


export const ExportResponsesDocument = gql`
    query ExportResponses($scheduledSurveyId: Int!, $language: Supported_language_code, $attributeValueIds: [Int!]!) {
  exportResponses(scheduledSurveyId: $scheduledSurveyId, language: $language, attributeValueIds: $attributeValueIds)
}
    `;

/**
 * __useExportResponsesQuery__
 *
 * To run a query within a React component, call `useExportResponsesQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportResponsesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportResponsesQuery({
 *   variables: {
 *      scheduledSurveyId: // value for 'scheduledSurveyId'
 *      language: // value for 'language'
 *      attributeValueIds: // value for 'attributeValueIds'
 *   },
 * });
 */
export function useExportResponsesQuery(baseOptions: Apollo.QueryHookOptions<ExportResponsesQuery, ExportResponsesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportResponsesQuery, ExportResponsesQueryVariables>(ExportResponsesDocument, options);
      }
export function useExportResponsesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportResponsesQuery, ExportResponsesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportResponsesQuery, ExportResponsesQueryVariables>(ExportResponsesDocument, options);
        }
export type ExportResponsesQueryHookResult = ReturnType<typeof useExportResponsesQuery>;
export type ExportResponsesLazyQueryHookResult = ReturnType<typeof useExportResponsesLazyQuery>;
export type ExportResponsesQueryResult = Apollo.QueryResult<ExportResponsesQuery, ExportResponsesQueryVariables>;